let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l1VFC")).then(() => parcelRequire('gkukM'));